import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { LibraryControlService } from 'oneorm-ccmt-api-http-client';
import { catchError, finalize, map, of } from 'rxjs';

import { OverlaySpinnerService } from '../../shared/components/overlay-spinner/overlay-spinner.service';
import { ROUTES } from '../../shared/constants/routes';

export function canActivateCurrentLibraryControl(): CanActivateFn {
  return (route: ActivatedRouteSnapshot) => {
    const id = route.paramMap.get('id');
    if (id === null) {
      return of(true);
    }

    const libraryControlService = inject(LibraryControlService);
    const router = inject(Router);
    const overlaySpinnerService = inject(OverlaySpinnerService);

    overlaySpinnerService.showLoader();

    return libraryControlService.getCurrentLibraryControl(id).pipe(
      map(current =>
        current.id === id ? true : new RedirectCommand(router.parseUrl(`/${ROUTES.libraryControl}/${current.id}`), { replaceUrl: true })
      ),
      catchError(() => of(true)),
      finalize(() => overlaySpinnerService.hideLoader())
    );
  };
}
